import { ImageMedia } from "../../../../../features/media/domain/models/media";
import { Platform } from "../../../../../shared/enums/campaignPost.enums";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";
import {
  IPublicationTemplate,
  RecommendedSchedule,
} from "./publication-template";

export class InstagramSingleImage implements IPublicationTemplate {
  public readonly type = PublicationTemplateType.InstagramSingleImage;
  public readonly platform = Platform.Instagram;
  public readonly isAd = false;

  constructor(
    public readonly id: string,
    public readonly text: string,
    public readonly image: ImageMedia,
    public readonly recommendedSchedules: RecommendedSchedule[],
  ) {}
}
